(function () {
    "use strict";
    realmCommerceApp.controller("MessagesController", MessagesController);

    /*@ngInject*/
    function MessagesController(toastr, messagesService) {
        var vm = this;
        vm.showMessages = showMessages;
        activate();
        function activate() {
            showMessages();
        }

        function showMessages() {
            var flashBagMessages = messagesService.getMessages();
            flashBagMessages.forEach(function (flashBagMessage) {
                switch (flashBagMessage.type) {
                    case 'error':
                        toastr.error(flashBagMessage.message);
                        break;
                    case 'success':
                        toastr.success(flashBagMessage.message);
                        break;
                    case 'warning':
                        toastr.warning(flashBagMessage.message);
                        break;
                    default :
                        toastr.info(flashBagMessage.message);
                }
            });
        }

    }
})();


// WEBPACK FOOTER //
// ./static/js/app/messages/messages.controller.js